import React from 'react';

import Stepper from 'components/Stepper';
import Button from 'components/deprecated/legacyElements/Button';
import H2 from 'components/deprecated/legacyElements/H2';
import styles from './style.module.scss';

export default ({
  currentUser,
  numEmployees,
  onAddRoom,
  onChange,
  onUpdateRoom,
  onSubmit,
  rooms,
  roomTypes,
  spacePerEmployee,
}) => (
  <section className={styles.spaceEstimationForm}>
    <H2>Space considerations:</H2>
    <label htmlFor="employeeCount">Number of employees</label>
    <input
      type="number"
      value={numEmployees}
      name="numEmployees"
      id="employeeCount"
      onChange={onChange}
    />
    <label htmlFor="employeeSpaceSelector">Space per employee</label>
    <div className="select" id="employeeSpaceSelector">
      <select
        value={spacePerEmployee}
        name="spacePerEmployee"
        onChange={onChange}
      >
        <option value={100}>Economy - 100 sqft</option>
        <option value={150}>Average - 150 sqft</option>
        <option value={200}>Spacious - 200 sqft</option>
      </select>
    </div>
    {rooms.length > 0 && (
      <div className={styles.recommendations}>
        <H2>What other spaces do you need?</H2>
        <ul className={styles.roomsList}>
          {rooms.map((room) => (
            <li key={room.name}>
              {room.name}
              <Stepper
                className={styles.buttonGroup}
                onChange={onUpdateRoom}
                value={room.count}
                name={room.name}
              />
            </li>
          ))}
        </ul>
        <div className="select">
          <select onChange={onAddRoom} value="Add">
            <option>Add</option>
            {roomTypes.map((roomType) => (
              <option key={roomType.name} value={roomType.name}>
                {roomType.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    )}
    {!currentUser && (
      <Button
        className={styles.submitButton}
        onClick={onSubmit}
        data-qa="space-calculator-submit"
      >
        Calculate space estimate
      </Button>
    )}
  </section>
);
